import * as React from 'react';
import {useClubs} from '@nls-2022/nls-bll';
import {useForm, Path, UseFormRegister, SubmitHandler} from 'react-hook-form';
import {ClubSearchActionType} from '@nls-2022/nls-bll';
import {ApiError} from '@nls-2022/nls-bll';
import {addClubBasicSocial} from '@nls-2022/nls-api';
import {Link} from 'react-router-dom';
import {NLSTextInput} from '../form/NLSTextInput';
//import Button from '@mui/material/Button';
//import Paper from '@mui/material/Paper';
//import TextField from '@mui/material/TextField';
//import Select from '@mui/material/Select';
//import InputLabel from '@mui/material/InputLabel';
//import FormControlLabel from '@mui/material/FormControlLabel';
//import Checkbox from '@mui/material/Checkbox';
//import {Redirect} from 'react-router-dom';

export interface IBasicSocialDetailsInputFormValues {
  Twitter: string;
  Instagram: string;
  Facebook: string;
  Wikipedia: string;
}

export type InputProps = {
  label: Path<IBasicSocialDetailsInputFormValues>;
  register: UseFormRegister<IBasicSocialDetailsInputFormValues>;
  required: boolean;
  rest: any;
};

export type ClubBasicSocialAddProps = {
  clubGuid: string;
};

const ClubBasicSocialAdd = ({
  clubGuid,
}: ClubBasicSocialAddProps): JSX.Element => {
  const [{clubs, clubStatus}, dispatch] = useClubs();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: {errors},
  } = useForm();

  const [formErrors, setFormErrors] = React.useState<Array<ApiError>>([]);
  const [socialAdded, setSocialAdded] = React.useState<boolean>(false);
  const instagram = watch('Instagram', '');
  const twitter = watch('Twitter', '');
  const facebook = watch('Facebook', '');
  const wikipedia = watch('Wikipedia', '');

  React.useEffect(() => {
    const initForm = () => {
      setValue('Instagram', '');
      setValue('Twitter', '');
      setValue('Facebook', '');
      setValue('Wikipedia', '');
    };
    initForm();
  }, [setValue]);

  const onSubmit = (data: any) => {
    try {
      //let clubDetail = addClub(data);
      addClubBasicSocial(data).then(clubDetail => {
        if (clubDetail!.fluentErrors?.length > 0) {
          setFormErrors(clubDetail!.fluentErrors);
        } else {
          setFormErrors([]);
          setSocialAdded(true);

          //dispatch({
          //  type: ClubSearchActionType.ClubAdd,
          //  clubDetail: clubDetail,
          //});
        }
      });
    } catch {}
  };
  if (socialAdded) {
    let socialAddedLink =
      '/NLSAdmin2/club/' +
      clubs?.find(u => u.ClubGuid === clubGuid)?.UrlFriendlyName;
    return <Link to={socialAddedLink} />;
  }
  return (
    <div data-testid="clubsocialbasicadd">
      <section>
        <form
          className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col"
          onSubmit={handleSubmit(onSubmit)}
        >
          <NLSTextInput
            register={register}
            defaultValue={wikipedia}
            name="Wikipedia"
            label="Wikipedia"
            errors={errors}
            validation={{required: {value: true, message: 'required'}}}
          />
          <br />

          <NLSTextInput
            register={register}
            defaultValue={twitter}
            name="Twitter"
            label="Twitter"
            errors={errors}
            validation={{required: false}}
          />
          <br />

          <NLSTextInput
            register={register}
            defaultValue={facebook}
            name="Facebook"
            label="Facebook"
            errors={errors}
            validation={{required: false}}
          />
          <br />
          <NLSTextInput
            register={register}
            defaultValue={instagram}
            name="Instagram"
            label="Instagram"
            errors={errors}
            validation={{required: false}}
          />
          <input id="ClubGuid" defaultValue={clubGuid} hidden />
          <br />
          <button
            className="flex-shrink-0 bg-green-500 hover:bg-green-700 border-green-500 hover:border-green-700 text-sm border-4 text-white py-1 px-2 rounded uppercase"
            type="submit"
          >
            Submit
          </button>
        </form>
      </section>
    </div>
  );
};

export default ClubBasicSocialAdd;
